import { Skeleton } from '@/components/ui/Skeleton.tsx';
import {
  InfoCard,
  InfoCardBody,
  InfoCardHeader,
} from '@/components/ui/InfoCard.tsx';

const SegmentRowSkeleton = () => (
  <div className="flex items-center gap-2.5">
    <Skeleton className="size-2 rounded-full" />
    <Skeleton className="h-3.5 w-24" />
    <Skeleton className="ml-auto h-4 w-20" />
  </div>
);

const CurrencyCardSkeleton = () => (
  <InfoCard>
    <InfoCardHeader title={<Skeleton className="h-3 w-10" />}>
      <Skeleton className="mt-1.5 h-3 w-20" />
    </InfoCardHeader>
    <InfoCardBody className="gap-3.5">
      <Skeleton className="h-7 w-40" />
      <Skeleton className="h-2 w-full rounded-full" />
      <div className="flex flex-col gap-2">
        <SegmentRowSkeleton />
        <SegmentRowSkeleton />
        <SegmentRowSkeleton />
      </div>
    </InfoCardBody>
  </InfoCard>
);

/** Szkielet zakładki Finanse — panel spraw, dwie karty walutowe i tabela. */
const TourFinancesTabSkeleton = () => (
  <div className="space-y-4">
    <Skeleton className="h-9 w-40 rounded-md" />

    <InfoCard>
      <InfoCardHeader title={<Skeleton className="h-3 w-44" />} />
      <InfoCardBody className="gap-3.5">
        <Skeleton className="h-9 w-full" />
        <Skeleton className="h-9 w-full" />
      </InfoCardBody>
    </InfoCard>

    <div className="grid gap-4 lg:grid-cols-2">
      <CurrencyCardSkeleton />
      <CurrencyCardSkeleton />
    </div>

    <Skeleton className="h-64 w-full rounded-[14px]" />
  </div>
);

export default TourFinancesTabSkeleton;
